document.addEventListener("DOMContentLoaded", () => {
  const scroll = localStorage.getItem("restoreScroll");
  const shouldOpen = localStorage.getItem("openDrawerAfterReload");

  if (scroll) {
    window.scrollTo(0, parseInt(scroll, 10));
    localStorage.removeItem("restoreScroll");
  }

  if (shouldOpen === "true") {
    let attempts = 0;

    const tryOpenDrawer = () => {
      const drawer = document.querySelector("cart-drawer");

      if (drawer && typeof drawer.open === "function") {
        // Use the native open path so focus is trapped and returned correctly.
        // Do not pre-toggle .active — that can skip transitionend / trapFocus.
        const cartLink = document.querySelector("#cart-icon-bubble");
        drawer.open(cartLink || undefined);
        localStorage.removeItem("openDrawerAfterReload");
      } else if (attempts < 10) {
        attempts += 1;
        setTimeout(tryOpenDrawer, 300);
      } else {
        localStorage.removeItem("openDrawerAfterReload");
      }
    };

    tryOpenDrawer();
  }
});
